import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import 'hammerjs';

import { FuseModule } from 'admin/@fuse/fuse.module';
import { FuseSharedModule } from 'admin/@fuse/shared.module';
import { FuseProgressBarModule, FuseThemeOptionsModule } from 'admin/@fuse/components';

import { fuseConfig } from 'admin/@template/fuse-config';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AngularDateHttpInterceptor } from 'admin/utile/interceptors/AngularDateHttpInterceptor';
import { UrlAppendHttpInterceptor } from 'admin/utile/interceptors/UrlAppendHttpInterceptor';

import { LayoutModule } from 'admin/@template/layout/layout.module';
import { AppDevLoginComponent } from './app-login.component';
import { FormsModule } from '@angular/forms';
import { DevForgotPassModule } from 'admin/userTemplate/app-login/main/forgot-pass/forgot-pass.module';
import { DevLoginModule } from 'admin/userTemplate/app-login/main/login/login.module';
import { DevRegisterModule } from 'admin/userTemplate/app-login/main/register/register.module';
import { DevCompanySignupModule } from 'admin/userTemplate/app-login/main/company-signup/company-signup.module';
import { DevCompanyJoinModule } from 'admin/userTemplate/app-login/main/company-join/company-join.module';


const appRoutes: Routes = [
    {
        path      : '**',
        redirectTo: 'login'
    }
];

@NgModule({
    declarations: [
        AppDevLoginComponent
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-TOKEN',
            headerName: 'X-XSRF-TOKEN',
        }),
        RouterModule.forRoot(appRoutes),

        FormsModule,

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,

        DevLoginModule,
        DevRegisterModule,
        DevCompanySignupModule,
        DevCompanyJoinModule,
        DevForgotPassModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UrlAppendHttpInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AngularDateHttpInterceptor,
            multi: true
        }
    ],
    bootstrap   : [
        AppDevLoginComponent
    ]
})
export class AppLoginModule
{
}
